var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-100" },
    [
      _c(
        "ob1-cards",
        {
          attrs: {
            "is-multiple": true,
            "is-inversed": _vm.isBlack,
            "with-composite-link": false,
          },
        },
        [
          _vm.offer.is5G
            ? _c("img", {
                staticClass: "logo-5g",
                attrs: { src: _vm.logo5gSrc, alt: "logo 5G Orange" },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.offer.is5G
            ? _c("div", { staticClass: "label-5g font-size-16 fw-bold" }, [
                _vm._v("\n            5G\n        "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showBanner(_vm.offer.banner)
            ? _c(
                "strong",
                { staticClass: "ob1-tag ob1-tag-primary card-tag" },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.offer.banner) + "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tile-content d-flex flex-column pt-2" }, [
            _c(
              "div",
              { staticClass: "title-wrapper px-1 px-xl-2 d-flex flex-column" },
              [
                _c("p", { staticClass: "pt-xl-1 py-0 mb-0 fw-bold" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.getTitle(_vm.offer.name) +
                          " " +
                          _vm.blockedAndUnBlockedLabel
                      ) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("h1", { staticClass: "py-0 mb-0" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.getSubTitle(_vm.offer.name, _vm.offer.is5G)) +
                      "\n                "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "price-wrapper",
                class: _vm.isShowOpenDiscountMessage
                  ? "my-1 mx-1 mx-xl-2 ps-1 bg-greige"
                  : "mb-0 px-1 px-xl-2",
              },
              [
                _c("ob1-prix-offre", {
                  attrs: {
                    price: _vm.offer.price.price,
                    duration: _vm.offer.price.duration,
                    "initial-price": _vm.offer.price.initialPrice,
                    "show-by-month": _vm.offer.price.showByMonth,
                    "show-from": _vm.offer.price.showFrom,
                    "show-promo-duration": _vm.offer.price.showPromoDuration,
                    "open-discount-message": _vm.offer.openDiscountMessage,
                    "price-details": _vm.offer.price.priceDetails,
                    "custom-commitment": "pt-0 d-block",
                    "is-inverse": _vm.isBlack && !_vm.isShowOpenDiscountMessage,
                    "is-compact": true,
                    "show-icon": false,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "claim-wrapper" }, [
              _vm.offer.claims
                ? _c(
                    "div",
                    { staticClass: "mb-1 mx-1 mx-xl-2" },
                    [
                      _vm._l(_vm.offer.claims, function (claim, index) {
                        return [
                          _c("offer-claim-cds", {
                            key: index,
                            attrs: { claim: claim, "is-black": _vm.isBlack },
                          }),
                        ]
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.advantageOfferMobileMessage
              ? _c(
                  "div",
                  {
                    staticClass:
                      "advantage-message-wrapper d-flex flex-row align-items-center px-1 px-xl-2",
                  },
                  [
                    _c("p", { staticClass: "mb-0 pt-0" }, [
                      _c("span", {
                        staticClass: "icon-Mobile-payment font-size-26",
                      }),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-0 pt-0" }, [
                      _c("span", { staticClass: "fw-bold" }, [
                        _vm._v(_vm._s(_vm.advantageOfferMobileMessage)),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex justify-content-center px-1 px-xl-2" },
              [
                _vm.offer.addOfferDto
                  ? _c("offer-cta-with-device-popin", {
                      staticClass: "mx-0 px-0 w-100",
                      attrs: {
                        "is-wide": true,
                        "is-primary": true,
                        "is-inverse": _vm.isBlack,
                        label: _vm.ctaLabel,
                        "offer-name": _vm.offer.name,
                        "popin-id":
                          "addOfferWithDevicePopIn-" + _vm.offer.idSeo,
                        "popin-ctas-dto":
                          _vm.offer.addOfferDto.popinWithDeviceCdsDto,
                        "from-cds": true,
                        "is-sub": _vm.isSub,
                        "tracking-category": _vm.ctaTrackingCategory,
                        "tracking-label": _vm.getLabelToTmsFormat(
                          _vm.offer.name
                        ),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.offer.addOfferWithAuthenticationDto
                  ? _c("offer-cta-with-device-popin", {
                      staticClass: "mx-0 px-0 w-100",
                      attrs: {
                        "is-wide": true,
                        "is-primary": true,
                        label: _vm.ctaLabel,
                        "offer-name": _vm.offer.name,
                        "popin-id":
                          "addOfferWithAuthenticationAndDevicePopIn-" +
                          _vm.offer.idSeo,
                        "popin-ctas-dto":
                          _vm.offer.addOfferWithAuthenticationDto
                            .popinWithDeviceCdsDto,
                        "from-cds": true,
                        "is-sub": _vm.isSub,
                        "tracking-category": _vm.ctaTrackingCategory,
                        "tracking-label": _vm.getLabelToTmsFormat(
                          _vm.offer.name
                        ),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.offer.addOfferInCartDto
                  ? _c("ob1-boutons", {
                      staticClass: "mx-0 px-0 w-100",
                      attrs: {
                        "is-button": true,
                        "is-primary": true,
                        label: _vm.offer.addOfferInCartDto.label,
                        "data-oevent-category": "tuile_forfait_vsim",
                        "data-oevent-action": "ajouter_au_panier",
                        "data-oevent-label": _vm.offer.name,
                      },
                      on: {
                        "ob1-boutons-click": function ($event) {
                          $event.preventDefault()
                          return _vm.onAddOfferInCart()
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-center pb-1 px-1 px-xl-2",
              },
              [
                _c("ob1-liens", {
                  attrs: {
                    "is-button": "",
                    "with-arrow": true,
                    "is-inverse": _vm.isBlack,
                    "data-bs-toggle": "modal",
                    "modal-id": "offer-details-popin",
                    text: _vm.linkCdsDetailPageOrConfigureLabel,
                    "data-oevent-category": _vm.ctaTrackingCategory,
                    "data-oevent-action": _vm.getLabelToTmsFormat(
                      _vm.offer.linkCdsDetailPageLabel
                    ),
                    "data-oevent-label": _vm.getLabelToTmsFormat(
                      _vm.offer.name
                    ),
                  },
                  on: {
                    "ob1-liens-click": function ($event) {
                      return _vm.openOffersPopin(_vm.offer)
                    },
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }